import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore, useIsSuperAdmin } from '../stores/authStore';

export default function SelectTenant() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, tenants, selectTenant } = useAuthStore();
  const isSuperAdmin = useIsSuperAdmin();

  if (!user) {
    navigate('/login');
    return null;
  }

  const choose = async (slug: string) => {
    await selectTenant(slug);
    navigate('/');
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-paper px-6">
      <div className="card w-full max-w-md p-8">
        <p className="eyebrow">{t('common.appName')}</p>
        <h1 className="page-title mt-1 mb-5">{t('selectTenant.title')}</h1>
        {tenants.length === 0 && (
          <p className="text-sm text-ink-muted">{t('selectTenant.empty')}</p>
        )}
        <ul className="space-y-2">
          {tenants.map((org) => (
            <li key={org.slug}>
              <button
                onClick={() => choose(org.slug)}
                className="group w-full rounded-lg border border-line-strong px-4 py-3 text-left transition-colors hover:border-brand hover:bg-brand-tint"
              >
                <div className="font-medium text-ink group-hover:text-brand-strong">{org.name}</div>
                <div className="text-xs text-ink-muted">
                  {org.slug}
                  {org.role && ` · ${t(`members.roles.${org.role}`, { defaultValue: org.role })}`}
                </div>
              </button>
            </li>
          ))}
        </ul>
        {isSuperAdmin && (
          <button
            onClick={() => navigate('/tenants')}
            className="mt-5 w-full rounded-lg bg-brand px-4 py-3 text-sm font-medium text-white transition-colors hover:bg-brand-strong"
          >
            {t('selectTenant.manageOrganizations')}
          </button>
        )}
      </div>
    </div>
  );
}
